import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import Modal from "react-modal";
import { selectUser } from "../../components/auth/auth.selector";
import HelmetWrapper from "../../HelmetWrapper";
import CommonStructured from "../../components/common-components/CommonStructured";
import { fetchBTLVendorsData } from "../../redux/prospect-reducers/prospectSlice";
import BTLLeadsListings from "../../components/btl-leads/BTLVendorListings";
import BTLVendorForm from "../../components/btl-leads/BTLVendorForm";

const BTLVendor = () => {
  const dispatch = useDispatch();
  const userInfoData = useSelector(selectUser);

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
  };
  const [filters, setFilters] = useState(iniFilters);
  const iniModvalues = {
    isModOpen: false,
    cardName: "",
    rowData: "",
    image: "",
  };
  const [modValues, setModValues] = useState(iniModvalues);

  const onCloseModal = () => {
    setModValues(iniModvalues);
  };

  function getBTLVendors(filters) {
    dispatch(
      fetchBTLVendorsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    getBTLVendors(filters);
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
    }));
  }, [isPage, pageLimit]);

  return (
    <HelmetWrapper title="WTF: BTL Vendors">
      <Container className="bg-cloud-k px-50px gobal-container" fluid>
        <Modal
          isOpen={modValues.isModOpen}
          onRequestClose={onCloseModal}
          contentLabel="Modal"
          ariaHideApp={false}
        >
          {modValues.cardName === "add" || modValues.cardName === "edit" ? (
            <BTLVendorForm
              userInfoData={userInfoData}
              rowData={modValues.rowData}
              isEdit={modValues.cardName === "edit"}
              closeModal={onCloseModal}
              callFunction={() => getBTLVendors(filters)}
            />
          ) : null}
        </Modal>

        <Row>
          <Col>
            <CommonStructured
              pageHeading={"BTL Vendors"}
              createBtnTxt={"+ Add New Vendor"}
              onClickCreateBtn={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  cardName: "add",
                }))
              }
              isReload={() => {
                getBTLVendors(filters);
              }}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <BTLLeadsListings
              userInfoData={userInfoData}
              isPage={isPage}
              setIsPage={setIsPage}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              setModValues={setModValues}
              callFunction={() => {
                getBTLVendors(filters);
              }}
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default BTLVendor;
